<template>
  <div class="mt-8">
    <px-view-module-header module-name="Empresa" :breadcrumbs="breadcrumbs"/>
    <v-card class="rounded-card card-shadow mt-8">
      <v-card-text class="text--primary">
        <px-view-header-title title="Usuários"/>
        <px-listagem-usuarios-header :on-click-refresh="onClickRefresh"
                                     @change="onChangeFilter"/>
        <px-lista-usuarios :usuarios="usuarios" :loading="loading"
                           :on-change-options="onChangeOptions"
                           :options-list="optionsList"
                           @update="onClickRefresh"/>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import ListaUsuarios from './ListaUsuarios.vue';
import ListagemUsuariosHeader from './ListagemUsuariosHeader.vue';
import UsuarioService from './usuario-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      usuarios: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'nome',
        sortDesc: true,
      },
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Usuários' },
      ],
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemUsuario', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.resetPage();
      this.getUsuarios();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getUsuarios();
    },
    onClickRefresh() {
      this.getUsuarios();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getUsuarios() {
      this.loading = true;
      this.listOptions.filter = this.stringFilter;
      const {
        limit,
        offset,
      } = this.listOptions;
      return UsuarioService.getUsers({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.usuarios = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    pxListaUsuarios: ListaUsuarios,
    pxListagemUsuariosHeader: ListagemUsuariosHeader,
  },
};
</script>
